<a
  [routerLink]="[]"
  fragment="top"
  [ngClass]="[
    showScrollTop() ? 'fade-in' : 'fade-out',
    scrollPosition() < 200 ? 'hide' : '',
  ]"
  class="scroll-to-top"
>
  <svg
    class="scroll-to-top-icon"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 8L1.41 9.41L7 3.83V16H9V3.83L14.58 9.42L16 8L8 0L0 8Z"
      fill="currentColor"
    />
  </svg>
</a>
